import AdminVaspsTableItem from './AdminVaspsTableItem'

export default AdminVaspsTableItem
